import "./without.css";

const WithoutSidebar = ({ children, footer = false, isLogin = false}) => {
  return (
    <>
      <div className={(isLogin ? "without-container": "without-background")}>
        <div className="parent-logoair">
          {
            isLogin &&
            <img src="/images/tahagasht-h.svg" />
          }
        </div>
        {children}
        <div className="footer">
          {footer && (
            <>
              <a
                referrerpolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=20389&Code=ACG0by7LWUZrELQc3c1m"
              >
                <img
                  referrerpolicy="origin"
                  src="/images/enamad.png"
                  alt=""
                  id="ACG0by7LWUZrELQc3c1m"
                />
              </a>
              <div className="item">
                <a className="a1" href="https://www.tahagasht.com/about-us">
                  درباره ما
                </a>
                <a className="a1" href="https://www.tahagasht.com/contact-us">
                  ارتباط با ما
                </a>
                <a
                  className="a1"
                  href="http://www.tahagasht.com/terms-and-conditions"
                >
                  قوانین و مقررات
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default WithoutSidebar;
